export default class HeroSection extends HTMLDivElement {

    connectedCallback() {

        if (this.videoElement != null && this.toggleButton != null)
            this.toggleButton.addEventListener("click", this.togglePlay);

    }

    togglePlay = () => {

        if (this.videoElement.paused) {
            this.toggleButton.querySelector(".icon-pause").classList.remove("d-none");
            this.toggleButton.querySelector(".icon-play").classList.add("d-none");
            this.videoElement.play();
            this.toggleButton.setAttribute("aria-label", "Stoppa video");
        }
        else {
            this.toggleButton.querySelector(".icon-pause").classList.add("d-none");
            this.toggleButton.querySelector(".icon-play").classList.remove("d-none");
            this.videoElement.pause();
            this.toggleButton.setAttribute("aria-label", "Starta video");
        }

    }

    get toggleButton() {
        return this.querySelector("button");
    }

    get videoElement() {
        return this.querySelector("video");
    }

}

customElements.define("hero-section", HeroSection, { extends: "div" });